module.exports = __webpack_public_path__ + "img/arrow-up-circle.11822613.svg";